import {
  FETCH_GROUP_REQUEST,
  FETCH_GROUP_SUCCESS,
  FETCH_GROUP_FAILURE,
} from './actions';
import {
  FETCH_SESSION_PLANS_REQUEST,
  FETCH_SESSION_PLANS_SUCCESS,
  FETCH_SESSION_PLANS_FAILURE,
} from 'data/SessionPlans/actions';
import {
  FETCH_PROGRESS_REPORTS_REQUEST,
  FETCH_PROGRESS_REPORTS_SUCCESS,
  FETCH_PROGRESS_REPORTS_FAILURE,
} from 'data/ProgressReports/actions';
import { updateGroupSessionPlansAttribute } from 'data/SessionPlans/reducer';
import { updateGroupProgressReportsAttribute } from 'data/ProgressReports/reducer';
import { ApiResponseHelper } from 'omni-common-ui';
import { Map } from 'immutable';
import Group from './model';

export default function groups(state = Map({}), action) {
  switch (action.type) {
    case FETCH_GROUP_REQUEST:
      return state.set(action.id, ApiResponseHelper.create({ loading: true }));
    case FETCH_GROUP_SUCCESS:
      return onSuccess(state, action, action.payload);
    case FETCH_GROUP_FAILURE:
      return state.set(action.id, ApiResponseHelper.create(new Error(action.error)));
    case FETCH_SESSION_PLANS_REQUEST:
    case FETCH_SESSION_PLANS_SUCCESS:
    case FETCH_SESSION_PLANS_FAILURE:
      return state.update(action.groupId, (group) =>
          group.update('data', (data) =>
              data.update('sessionPlans', (sessionPlans) =>
                  updateGroupSessionPlansAttribute(sessionPlans, action))));
    case FETCH_PROGRESS_REPORTS_REQUEST:
    case FETCH_PROGRESS_REPORTS_SUCCESS:
    case FETCH_PROGRESS_REPORTS_FAILURE:
      return state.update(action.groupId, (group) =>
          group.update('data', (data) =>
              data.update('progressReports', (progressReports) =>
                  updateGroupProgressReportsAttribute(progressReports, action))));
    default:
      return state;
  }
}

function onSuccess(state, action, apiGroup) {
  const newGroup = Group.create(Object.assign({}, apiGroup, {
    closedTime: apiGroup.closedDatetime,
    currentSessionId: apiGroup.currentSessionPlanId,
    // stringify ids
    id: `${apiGroup.id}`,
    centreId: `${apiGroup.centreId}`,
  }));

  return state.set(action.id, ApiResponseHelper.create(newGroup));
}



// WEBPACK FOOTER //
// ./containers/Group/reducer.js